// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2293a0c9","732":"f232598f","977":"318e25d2"}[chunkId] + ".chunk.js";
};